'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.masonry = twentyninetimes.masonry || function () {

	function init() {
		let masonryGrid = document.querySelectorAll('.js-masonry-grid');
		if ( masonryGrid ) {
			masonryInit(masonryGrid);
		}
	}

	function masonryInit(masonryGrid) {
		masonryGrid.forEach((grid) => {
		    var msnry = new Masonry( grid,{
		        columnWidth: '.grid-sizer',
		        itemSelector: '.js-grid-item',
		        initLayout: false,
		        percentPosition: true
		    });

		    msnry.on( 'layoutComplete', function( items ) {
		      console.log( items.length );
		    });
		    // trigger initial layout
		    msnry.layout();

		});
	}

	return {
		init : init
	};

}();